// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import PortfolioAnalysisDashboard from '@/features/energyxplorer/portfolio/components/datagrid/overview-datagrid/PortfolioAnalysisDashboard';
import PortfolioAnalysisDashboardDatagrid from '@/features/energyxplorer/portfolio/components/datagrid/overview-datagrid/PortfolioAnalysisDashboardDatagrid';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/overview/standard',
)({
  component: RouteComponent,
  staticData: { crumb: 'glossary:overview' },
});

function RouteComponent() {
  return (
    <PortfolioAnalysisDashboard
      DatagridComponent={PortfolioAnalysisDashboardDatagrid}
    />
  );
}
